import axios from 'axios';
import { BASE_URL } from './apiconfig';

export const getUploadUrl = async (token: string | null, params: { fileName: string, contentType: string, folder: 'promos' | 'notifications' }) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/images/upload-url`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return data;
  } catch (error) {
    console.log("Failed to get upload URL. ", error);
    throw error;
  }
}

export const uploadImage = async (token: string | null, file: File, folder: 'promos' | 'notifications'): Promise<string> => {
  // 1. Get presigned URL
  const response = await getUploadUrl(token, {
    fileName: file.name,
    contentType: file.type,
    folder,
  });

  const { uploadUrl, imageKey } = response.data;

  // 2. Upload to S3
  await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });

  // 3. Return the key
  return imageKey;
}
